// extracted by mini-css-extract-plugin
export default {"container":"Loading_container__NTcc7","tip":"Loading_tip__kzkLV"};